module.exports = __webpack_public_path__ + "img/contact.4fcb9004.jpg";